import { action } from '@/lib/api.js';
import { store } from '@/redux/lib/configureStore.js';
import setQuery from '@/lib/setQuery.js';
import { query } from '@/redux/selectors/querySelectors';

const setActiveSteps = ({ steps = [], clear = false }) => {
  const state = store.getState();
  const selectedSteps = state?.workflow?.selectedSteps;
  const stepId = query(state, 'stepId');

  const noChange = steps?.join('|') === selectedSteps?.join('|') && selectedSteps?.includes(stepId);
  if (noChange) {
    return;
  }

  if (steps?.length < 1 && !clear) {
    return;
  }

  action('SET_WORKFLOW_SELECTED_STEPS', steps);
  const newStepId = steps?.length !== 1 ? null : steps?.[0];
  if (newStepId === stepId) {
    return;
  }
  setQuery({ stepId: newStepId, stepTab: null });
};

export default setActiveSteps;
